import { render, staticRenderFns } from "./setThirdClassDialog.vue?vue&type=template&id=bb6d5c9e&scoped=true"
import script from "./setThirdClassDialog.vue?vue&type=script&lang=js"
export * from "./setThirdClassDialog.vue?vue&type=script&lang=js"
import style0 from "./setThirdClassDialog.vue?vue&type=style&index=0&id=bb6d5c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6d5c9e",
  null
  
)

export default component.exports